import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import CartonsDemenagement from "@/pages/CartonsDemenagement";
import CartonsReconditionnes from "@/pages/CartonsReconditionnes";
import EmballageProtection from "@/pages/EmballageProtection";
import FermetureAccessoires from "@/pages/FermetureAccessoires";
import PacksCartons from "@/pages/PacksCartons";
import DepartmentPage from "@/pages/DepartmentPage";
import CityPage from "@/pages/CityPage";
import YvelinesCityPage from "@/pages/YvelinesCityPage";
import NotFound from "@/pages/NotFound";

/**
 * React Router 7 ne supporte pas les segments dynamiques après un tiret
 * (pattern `-:slug`). Cette route attrape les URLs plates type
 * `/carton-demenagement-versailles` et délègue à YvelinesCityPage.
 */
const FlatYvelinesRoute = () => {
  const { pathname } = useLocation();
  const match = pathname.match(/^\/carton-demenagement-([a-z0-9-]+)\/?$/i);
  if (match) {
    return <YvelinesCityPage citySlugOverride={match[1]} />;
  }
  return <NotFound />;
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#FAFAFA] text-zinc-900">
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/produit/:slug" element={<ProductDetail />} />
              <Route path="/commande" element={<Checkout />} />
              <Route path="/confirmation/:orderId" element={<Confirmation />} />
              <Route path="/cartons-demenagement" element={<CartonsDemenagement />} />
              <Route path="/cartons-demenagement/:slug" element={<DepartmentPage />} />
              <Route path="/carton-demenagement/:citySlug" element={<CityPage />} />
              {/* URLs plates Yvelines (/carton-demenagement-versailles, etc.)
                  sont attrapées par le wildcard `*` ci-dessous via FlatYvelinesRoute,
                  car React Router 7 ne supporte pas le pattern `-:slug`. */}
              <Route path="/cartons-reconditionnes" element={<CartonsReconditionnes />} />
              <Route path="/emballage-protection" element={<EmballageProtection />} />
              <Route path="/fermeture-accessoires" element={<FermetureAccessoires />} />
              <Route path="/packs-cartons" element={<PacksCartons />} />
              <Route path="*" element={<FlatYvelinesRoute />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
